<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="事件名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'eventName',
              {
                rules: [
                  { required: true, message: '请输入事件名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入事件名称"
          />
        </a-form-item>

        <a-form-item
          label="邀请类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'inviteType',
              { rules: [{ required: true, message: '请选择邀请类型' }] },
            ]"
            :triggerChange="true"
            placeholder="请选择邀请方式"
            dictCode="dic_invite_type"
          />
        </a-form-item>

        <a-form-item
          label="邀请上限"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="test"
            :min="1"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="inviteMaxnum"
            v-decorator="['inviteMaxnum']"
            placeholder="请输入最大邀请人数"
          />
        </a-form-item>
        <a-form-item
          label="单位人数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="test"
            :min="1"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="teamNum"
            v-decorator="[
              'teamNum',
              { rules: [{ required: true, message: '请填写单位人数' }] },
            ]"
            placeholder="若为逐个邀请，则表示每邀请多少人，发一个奖品；若为组队邀请，则表示队伍人数"
          />
        </a-form-item>
        <a-form-item
          label="邀请人关联奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['prizesidInviter']"
            placeholder="请选择关联奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="被邀请人关联奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['prizesidInvitee']"
            placeholder="请选择关联奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!--<a-form-item label="启用状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag  v-decorator="['status', { rules: [{ required: true, message: '请选择启用状态' }] }]" :triggerChange="true" placeholder="请选择启用状态" dictCode="obj_status"/>
          &lt;!&ndash;<a-switch checked-children="启用" un-checked-children="禁用" v-decorator="['status']" v-show="Ok" default-checked/>
          <a-switch checked-children="启用" un-checked-children="禁用" v-decorator="['status']" v-show="unOk"/>&ndash;&gt;
        </a-form-item>-->

        <a-form-item
          label="邀请排行榜数据类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="typeChangeHandle"
            v-decorator="[
              'inviteRankingType',
              {
                rules: [
                  { required: true, message: '请选择邀请排行榜数据展示类型' },
                ],
              },
            ]"
            :triggerChange="true"
            placeholder="请选择邀请排行榜数据展示类型"
            dictCode="invite_ranking_type"
          />
        </a-form-item>

        <a-form-item
          v-if="showDateFlag"
          label="指定日期区间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-range-picker
            format="YYYY-MM-DD"
            :disabled-date="disabledDate"
            v-decorator="[
              'rankingDate',
              { rules: [{ required: true, message: '请选择排行榜日期区间' }] },
            ]"
            :show-time="{
              hideDisabledOptions: true,
              defaultValue: [moment('00:00:00'), moment('11:59:59')],
            }"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'InviteEventManageModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  data() {
    return {
      showDateFlag: false,
      prizesList: [], //奖品列表
      productList: [
        {
          fundCode: '111111',
          fundName: '测试数据1',
        },
        {
          fundCode: '222222',
          fundName: '测试数据2',
        },
      ], //产品列表
      nextPeriodConfigShow: false, //体验周期不是永久时配置项显示
      prizeProbability: '',
      receiveTypes: [
        {
          name: '一键领取',
          value: '1',
        },
        {
          name: '自由选择',
          value: '2',
        },
      ],
      goldEndOption: [
        {
          name: '系统自动买入',
          value: '1',
        },
        {
          name: '用户手动领取',
          value: '2',
        },
      ],

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 900,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/event/invite/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/event/invite/edit',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      /*if(this.model.prizesidInviter){
            this.model.prizesidInviter = this.model.prizesidInviter.split(",");
          }else{
            this.model.prizesidInviter = [];
          }
          if(this.model.prizesidInvitee){
            this.model.prizesidInvitee = this.model.prizesidInvitee.split(",");
          }else{
            this.model.prizesidInvitee = [];
          }
*/

      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'rankingDate',
            'inviteRankingType',
            'eventName',
            'inviteType',
            'inviteMaxnum',
            'teamNum',
            'prizesidInviter',
            'prizesidInvitee',
            'status'
          )
        );
      });

      if (this.model.inviteRankingType === '3') {
        this.showDateFlag = true;
      } else {
        this.showDateFlag = false;
      }

      if (this.model.rankingDate) {
        var ary = this.model.rankingDate.split('~');
        this.model.rankingDate = [
          moment(ary[0], 'YYYY-MM-DD'),
          moment(ary[1], 'YYYY-MM-DD'),
        ];
      }

      this.getPrizeList();
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          if (formData.rankingDate && formData.rankingDate.length !== 0) {
            formData.rankingDate =
              formData.rankingDate[0].format('YYYY-MM-DD') +
              '~' +
              formData.rankingDate[1].format('YYYY-MM-DD');
          } else {
            formData.rankingDate = '';
          }

          //formData.prizesidInviter = formData.prizesidInviter.toString();
          //formData.prizesidInvitee = formData.prizesidInvitee.toString();

          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'rankingDate',
          'inviteRankingType',
          'eventName',
          'inviteType',
          'inviteMaxnum',
          'teamNum',
          'prizesidInviter',
          'prizesidInvitee',
          'status'
        )
      );
    },

    /**获取奖品列表*/
    getPrizeList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/market/prize/getPrizeList';
      getAction(getUrl, {}).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
        }
      });
    },

    receiveTypesValue(e) {},

    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    },

    disabledRangeTime(_, type) {
      if (type === 'start') {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },

    typeChangeHandle(e) {
      if (e === '3') {
        this.showDateFlag = true;
      } else {
        this.showDateFlag = false;
      }
    },
  },
};
</script>
